import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_BASEURL,
    timeout: 500000
});

export default instance;
